export default __webpack_public_path__ + "static/media/stethoscope.0dca2830.png";